module.exports = "<mdl-switch [formControl]=\"isAccessibleFC\"></mdl-switch>"